import { Language, LanguageMap, Subsidiary, SubsidiaryMap } from '@coolblue-development/constants';

export const legacyBaseUrls: SubsidiaryMap<Partial<LanguageMap<string>>> = {
  [Subsidiary.NL]: {
    [Language.DUTCH]: 'https://www.werkenbijcoolblue.nl',
    [Language.ENGLISH]: 'https://www.careersatcoolblue.com'
  },
  [Subsidiary.BE]: {
    [Language.DUTCH]: 'https://www.werkenbijcoolblue.be',
    [Language.FRENCH]: 'https://www.travaillerchezcoolblue.be'
  },
  [Subsidiary.DE]: {
    [Language.GERMAN]: 'https://www.arbeitenbeicoolblue.de'
  }
} as const;
